import React from "react"
import clsx from "clsx"
import {Heading, Text} from "@chakra-ui/react"

type PageTitleProps = {
    title: string,
    subTitle?: string,
    extra?: React.ReactNode
}

function PageTitle({title, subTitle, extra}: PageTitleProps) {

    return <header>
        <div className={clsx(extra && "flex justify-between items-center")}>
            <div>
                <Heading size="md" fontWeight="semibold">{title}</Heading>
                <Text fontSize="lg">{subTitle}</Text>
            </div>
            {extra}
        </div>
    </header>
}

export {PageTitle}